import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [1, 5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "The red curve presents the spectrum of a signal. The maximum frequency of this signal is 200 Hz. This signal is sampled at Fs. Modify the sampling frequency and observe the replicas.",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "iframe",
                  options: {
                    src: `${config.IFRAMES_REACT_URL}/0305a/`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
